import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';
import { MetadataPropTypesShape } from '@Components/Results/MetadataPropTypes';
import ReactTargetHelper from '@Components/Results/services/react-target-helper.service';
import uuid from 'uuid/v4';

import './TargetRightHandLinks.scss';

function TargetRightHandLinks({ metadata, target, trackingAttrs, detailsExpanded }) {
  const openElementLink = useCallback(
    (type) => {
      if (typeof metadata !== 'undefined') {
        const requestParams = {
          hitSetKey: metadata.hitSetKey,
          resultName: metadata.resultName,
          searchId: metadata.searchId || uuid(),
        };

        if (metadata.order) {
          requestParams.order = metadata.order;
        }

        ReactTargetHelper.openElementLink(type, target, requestParams);
      }
    },
    [metadata, target]
  );

  const getTrackingAttrs = useCallback(
    () => ({
      ...trackingAttrs,
      'data-tracking': !detailsExpanded,
      'data-tracking-type': 'contentview,contentlinkclick',
      'data-tracking-action': 'target details',
    }),
    [trackingAttrs, detailsExpanded]
  );

  return (
    <div className="target-details-right els-btn-group-vertical">
      {target.substancesCount > 0 && (
        <ButtonWithIcon
          data-e2e="target-substances-link"
          key="substances"
          sprite="ChevronRight"
          type="link"
          linkIconSize="xs"
          iconRight
          className="target-right-hand-link e2e-righthand-link"
          onClick={() => openElementLink('substances')}
          {...getTrackingAttrs()}>
          Substances - {target.substancesCount}
        </ButtonWithIcon>
      )}
      {target.documentsCount > 0 && (
        <ButtonWithIcon
          data-e2e="target-documents-link"
          key="documents"
          sprite="ChevronRight"
          type="link"
          linkIconSize="xs"
          iconRight
          className="target-right-hand-link e2e-righthand-link"
          onClick={() => openElementLink('documents')}
          {...getTrackingAttrs()}>
          Documents - {target.documentsCount}
        </ButtonWithIcon>
      )}
    </div>
  );
}

TargetRightHandLinks.propTypes = {
  metadata: MetadataPropTypesShape,
  target: PropTypes.object.isRequired,
  trackingAttrs: PropTypes.object,
  detailsExpanded: PropTypes.bool,
};

export default TargetRightHandLinks;
